import Vue from 'vue'
import Router from 'vue-router'
import Store from '../store'

import VerifierView from '@/views/VerifierView'
import LoginView from '@/views/LoginView'
import CatchPhrase from '@/views/CatchPhrase'
import UsersView from '@/views/UsersView'
import ManageView from '@/views/ManageView'
import NoAccessView from '@/views/NoAccessView'
import SearchProviderView from '@/views/SearchProviderView'
import MapView from '@/views/MapView'
import UpgradeView from '@/views/UpgradeView'
import { getUserObject } from '../store'


Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/login',
			name: 'login',
			component: LoginView,
			meta: {
				title: 'Googli',
				icon:'../assets/logo2.png'
			}
		},
		{
			path: '/catch',
			name: 'CatchPhrase',
			component: CatchPhrase,
			meta: {
				requiresAuth: true,
				title: 'Googli',
				icon:'../assets/logo2.png'
			}
		},
		{
			path: '/manage',
			name: 'ManageView',
			component: ManageView,
			meta: {
				requiresAuth: true,
				title: 'Googli',
				icon:'../assets/logo2.png'

			}
		},
		{
			path: '/provider',
			name: 'SearchProviderView',
			component: SearchProviderView,
			meta: {
				requiresAuth: true,
				title: 'Googli',
				icon:'../assets/logo2.png'

			}
		},
		{
			path: '/users',
			name: 'UsersView',
			component: UsersView,
			meta: {
				requiresAuth: true,
				title: 'Googli',
				icon:'../assets/logo2.png'

			}
		},
		{
			path: '/map',
			name: 'MapView',
			component: MapView,
			meta: {
				requiresAuth: true,
				title: 'Googli',
				icon:'../assets/logo2.png'

			}
		},
		{
			path: '/',
			name: 'VerifierView',
			component: VerifierView,
			meta: {
				requiresAuth: true,
				title: 'Googli',
				icon:'../assets/logo2.png'

			}
		},
		{
			path: '/upgrade',
			name: 'UpgradeView',
			component: UpgradeView,
			meta: {
				requiresAuth: true,
				title: 'Googli',
				icon:'../assets/logo2.png'

			}
		},
		{
			path: '/no',
			name: 'noAccess',
			component: NoAccessView,
			title: 'Googli',
			icon:'../assets/logo2.png'

		},
		// {
		// 	path: '/logs',
		// 	redirect: { path: '/test/test.txt' },
		// },
		{
			path: '/:catchAll(.*)',

			redirect: { path: '/', name: 'VerifierView', component: VerifierView, meta: {
				requiresAuth: true,
				title: 'Googli',
				icon:'../assets/logo2.png'

			} }
		}
	]
})

router.beforeEach(async (to, from, next) => {
	const authenticated = localStorage.getItem('authenticated')
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
	if (requiresAuth && authenticated !== 'true') next('login')
	else next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js